import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=a64f5e02&scoped=true"
import script from "./send-message.vue?vue&type=script&lang=js"
export * from "./send-message.vue?vue&type=script&lang=js"
import style0 from "./send-message.vue?vue&type=style&index=0&id=a64f5e02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f5e02",
  null
  
)

export default component.exports